import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  Tooltip
} from "@chakra-ui/react";
import { MouseEvent, ReactNode, useState } from "react";

export interface IconButtonWithLoadingProps extends Omit<
  IconButtonProps,
  "onClick"
> {
  onClick?: (e: MouseEvent) => Promise<any>;
  tooltipMessage?: ReactNode | string;
}

export function IconButtonWithLoading({
  children,
  onClick,
  tooltipMessage,
  ...rest
}: IconButtonWithLoadingProps) {
  const [isLoading, setLoading] = useState(false);
  return tooltipMessage ? (
    <Tooltip
      label={tooltipMessage}
      bg="white"
      border="1px solid var(--chakra-colors-custom-gray)"
      color="prymary.500"
      boxShadow="none"
      borderRadius="10px"
    >
      <IconButton
        onClick={async (e) => {
          setLoading(true);
          await onClick?.(e);
          setLoading(false);
        }}
        isLoading={isLoading}
        {...rest}
      >
        {children}
      </IconButton>
    </Tooltip>
  ) : (
    <IconButton
      onClick={async (e) => {
        setLoading(true);
        await onClick?.(e);
        setLoading(false);
      }}
      isLoading={isLoading}
      {...rest}
    >
      {children}
    </IconButton>
  );
}

export interface ButtonWithLoadingProps extends Omit<ButtonProps, "onClick"> {
  onClick?: (e: MouseEvent) => Promise<any>;
  tooltipMessage?: string;
}

export function ButtonWithLoading({
  children,
  onClick,
  tooltipMessage,
  ...rest
}: ButtonWithLoadingProps) {
  const [isLoading, setLoading] = useState(false);
  return tooltipMessage ? (
    <Tooltip
      label={tooltipMessage}
      bg="white"
      border="1px solid var(--chakra-colors-custom-gray)"
      color="prymary.500"
      boxShadow="none"
      borderRadius="10px"
    >
      <Button
        onClick={async (e) => {
          setLoading(true);
          await onClick?.(e);
          setLoading(false);
        }}
        isLoading={isLoading}
        {...rest}
      >
        {children}
      </Button>
    </Tooltip>
  ) : (
    <Button
      onClick={async (e) => {
        setLoading(true);
        await onClick?.(e);
        setLoading(false);
      }}
      isLoading={isLoading}
      {...rest}
    >
      {children}
    </Button>
  );
}
